/**
 * Created with Mei Zhiwei on 2018-08-13 17:56:53.
 * Description: 文档类型，目录类型，目前是相同的值
 *
 * @author meizhiwei@meituan.com
 * @version 1.0.0
 * @Last Modified by meizhiwei@meituan.com
 * @Last Modified time 2018-08-13 17:56:53
 */
export const tocs = {
  'meituanCouponSolution': 10,
  'orderSolution': 20,
  'qrpaySolution': 200,
  'shopSolution': 30,
  'productSolution': 40,
  'help': 100
}



// WEBPACK FOOTER //
// ./src/config/tocs.js